import { Chrome } from 'vue-color';
import { ToggleButton } from 'vue-js-toggle-button';
import { VueEditor } from "vue2-editor";
import { Datetime } from 'vue-datetime';
import moment from 'moment';

if($('#component-network-group-editor').length){
    var app = new Vue({
        el: '#component-network-group-editor',
        data: {
            networkGroup:{
                name:'',
                strapline:'',
                description:'',
                colour:'#FF6965',
                image_location_file:'',
                image_location:'https://cdn.leadingedgeonly.com/files/platform-images/Mkv33n8JMlxhU413WbL0o7tzA8lp2gsU3xRuQEkp-card.jpg',
                header_banner_image_file:'',
                header_banner_image:'https://'+awsUrl+'/25/D3lcLGDuVhF7pvqqxvozuZSwvgMMoT4Pg5ErFSl3.jpg',
                owner_id:currentUserId,
                background: ''
            },
            account:{
                accountType:{}
            },
            loadingMessage:'Loading Organisation Editor',
            newUserEmail:'',
            selectedSector: null,
            loading:true,
            nameFocus:false,
            straplineFocus:false,
            descriptionFocus:false,
            openColorPicker:false,
            uploaderErrors:[],
            networkGroupSlug: networkGroupSlug,
            currentUserId: currentUserId,
            showUploadMedia: false,
            dataImages: [],
            targetId: '',
            imageMedia: false,
            bannerMedia: false,
            backgroundFocus: false
        },
        methods: {
            getAccountByUser(){
                axios.get('/api/v1/account/current-user')
                .then((response) =>  {
                    this.account = response.data;
                })
                .catch((error) =>  {
                    if(error.response){
                        this.$toasted.error(error.response.data);
                    }
                    this.loading = false;
                })
            },
            getNetworkGroup(slug){
                axios.get('/api/v1/network-group/'+slug)
                .then((response) =>  {
                    this.networkGroup = response.data;
                    this.account = response.data.account;

                    this.$nextTick(function () {
                        this.loading = false;
                        $(".tooltipped").tooltip();
                        this.manualGrow('name');
                        this.manualGrow('strapline');
                        this.manualGrow('description');
                        this.manualGrow('background');
                    });
                })
                .catch((error) =>  {
                    this.$toasted.error(error.response.data);
                    this.loading = false;
                })
            },
            saveNetworkGroup(){
                if(this.validate()){
                    var form =  document.getElementById('editor-preview');
                    var formData = new FormData(form);
                    formData = this.appendFields(formData);
                    this.loading = true;
                    this.loadingMessage = 'Saving organisation';

                    if ((!this.networkGroup.id && !this.networkGroup.image_location_file) || this.imageMedia === true) {
                        formData.append('image_location', this.networkGroup.image_location.replace("//" + this.awsUrl + "/", ""));
                        this.imageMedia = false;
                    } else if (this.networkGroup.image_location_file) {
                        formData.append('image_location', this.networkGroup.image_location_file);
                    }
                    if ((!this.networkGroup.id && !this.networkGroup.header_banner_image_file) || this.bannerMedia === true) {
                        formData.append('header_banner_image', this.networkGroup.header_banner_image.replace("//" + this.awsUrl + "/", ""));
                        this.bannerMedia = false;
                    } else if (this.networkGroup.header_banner_image_file) {
                        formData.append('header_banner_image', this.networkGroup.header_banner_image_file);
                    }

                    axios.post('/api/v1/network-group/'+this.networkGroup.slug, formData)
                    .then((response) =>  {
                        this.getNetworkGroup(this.networkGroupSlug);
                        this.$toasted.success('Your organisation has been Saved');
                    })
                    .catch((error) =>  {
                        this.$toasted.error(error.response.data);
                        this.loading = false;
                    });
                }
            },
            updateColour(colours){
                this.networkGroup.colour = colours.hex;
            },
            previewLogoImage(fileBlob, file) {
                if (fileBlob && file) {
                    this.networkGroup.image_location = fileBlob;
                    this.networkGroup.image_location_file = file;
                    this.showUploadMedia = false;
                    this.saveNetworkGroup(this.networkGroup.network_status_slug);
                }
            },
            previewBannerImage(fileBlob, file) {
                if (fileBlob && file) {
                    this.networkGroup.header_banner_image = fileBlob;
                    this.networkGroup.header_banner_image_file = file;
                    this.showUploadMedia = false;
                    this.saveNetworkGroup(this.networkGroup.network_status_slug);
                }
            },
            appendFields(formData) {
                formData.append('name', this.networkGroup.name);
                formData.append('strapline', this.networkGroup.strapline);
                formData.append('description', this.networkGroup.description);
                formData.append('colour', this.networkGroup.colour);
                formData.append('background', this.networkGroup.background);
                return formData;
            },
            validate(){
                let networkGroup = this.networkGroup;

                if(!networkGroup.name){
                    this.$toasted.error('Your organisation must have a name');
                    return false;
                }

                if(!networkGroup.strapline){
                    this.$toasted.error('Your organisation must have a strapline');
                    return false;
                }

                if(!networkGroup.description){
                    this.$toasted.error('Your organisation must have a description');
                    return false;
                }

                if(!networkGroup.colour){
                    this.$toasted.error('Your organisation must have a colour');
                    return false;
                }

                return true;
            },
            getTime(time){
                var testDateUtc = moment.utc(time);
                var localDate = testDateUtc.local();
                return localDate.format('LLL');
            },
            autoGrow($event){
                var element = $event.target;
                element.style.height = "5px";
                element.style.height = (element.scrollHeight)+"px";
            },
            manualGrow(name){
                var element = document.getElementById(name);
                element.style.height = "5px";
                element.style.height = (element.scrollHeight)+"px";
            },
            focusEditor(ref){
                this.$nextTick(function () {
                    ref.focus();
                });
            },
            descriptionCheck(){
                if(this.networkGroup.description == 'Please add a description'){
                    this.networkGroup.description = '';
                }
            },
            backgroundCheck() {
                if (this.networkGroup.background === 'Please add a background') {
                    this.networkGroup.background = '';
                }
            },
            uploadMedia(id) {
                this.getUploadedMedia();
                this.targetId = id;
                this.showUploadMedia = true;
            },
            getUploadedMedia() {
                axios.get('/api/v1/get-uploaded-media')
                    .then((response) => {
                        if (response.data.hasOwnProperty('uploads')) {
                            this.dataImages = response.data.uploads;
                        }
                    })
                    .catch((error) => {
                        this.errorHandler(error);
                    })
            },
            onSelectImage(data) {
                if (this.targetId === 'image') {
                    this.networkGroup.image_location = data.src;
                    this.imageMedia = true;
                    this.saveNetworkGroup(this.networkGroup.network_status_slug);
                } else if (this.targetId === 'banner') {
                    this.networkGroup.header_banner_image = data.src;
                    this.bannerMedia = true;
                    this.saveNetworkGroup(this.networkGroup.network_status_slug);
                }
                this.showUploadMedia = false;
            },
            selectMethod(result, files) {
                if (result == 'EXTENSION_ERROR') {
                    this.$toasted.error('The selected files contain invalid extensions.');
                    return;
                } else if (result == 'FILE_SIZE_ERROR') {
                    this.$toasted.error('The selected files size exceeded limit.');
                    return;
                }

                if (files && files[0]) {
                    let file = files[0], vm = this, img = new Image();
                    img.onload = function () {
                        if (this.width > 3000 || this.height > 3000) {
                            vm.$toasted.error('The selected image dimensions exceeded limit (3000*3000).');
                        } else {
                            if (vm.targetId === 'image') {
                                vm.previewLogoImage(img.src, file);
                            } else if (vm.targetId === 'banner') {
                                vm.previewBannerImage(img.src, file);
                            }
                        }
                    }
                    img.src = URL.createObjectURL(file);
                }
            }
        },
        mounted () {
            this.getNetworkGroup(this.networkGroupSlug);

            $('textarea').keypress(function(event) {
                if (event.keyCode == 13) {
                    event.preventDefault();
                    $(this).blur();
                }
            });
        },
        updated: function () {
        },
        components: {
            'chrome-picker': Chrome,
            'ToggleButton': ToggleButton,
            'vue-editor': VueEditor,
            'Datetime': Datetime
        },
    });
}